export const TRANSLATIONS_ES = {
    of: 'de',
    to: 'a',
    available: 'Disponible',
    seeDetails: 'Ver detalle',
    sessionErrorTitle: 'Sesión caducada',
    sessionErrorDescription: 'Tu sesión de usuario ha caducado o ya no es válida. Debes acceder de nuevo.',
    genericErrorTitle: 'Algo ha fallado',
    genericErrorDescription:
        'En este momento Mi O2 está experimentando problemas técnicos. Por favor inténtalo más tarde, estamos trabajando para solucionarlo cuanto antes.',
    januaryShort: 'ene',
    februaryShort: 'feb',
    marchShort: 'mar',
    aprilShort: 'abr',
    mayShort: 'may',
    juneShort: 'jun',
    julyShort: 'jul',
    augustShort: 'ago',
    septemberShort: 'sept',
    octuberShort: 'oct',
    novemberShort: 'nov',
    decemberShort: 'dic',
    january: 'Enero',
    february: 'Febrero',
    march: 'Marzo',
    april: 'Abril',
    may: 'Mayo',
    june: 'Junio',
    july: 'Julio',
    august: 'Agosto',
    september: 'Septiembre',
    octuber: 'Octubre',
    november: 'Noviembre',
    december: 'Diciembre',
    loading: 'Cargando',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sabado',
    login: 'Iniciar sesión',
    yes: 'Sí',
    no: 'No',
    informationUserLight: 'Inicia sesión de nuevo para acceder a esta información.',
    errorValidateOTP: 'No se ha podido validar el otp',
    notAccesible: 'Actualmente no puedes acceder, pruebe más adelante',
    updateAppstore:
        'No puedes acceder a la app porque tu versión actual está desactualizada.\n\n Por favor, ve a tu app store para instalar la última versión.',
    updateApp: 'Actualiza la app',
    permanent: 'Fijo',
    mobile: 'Móvil',
    devicesSection: 'Dispositivos y servicio técnico',
    rates: 'Tarifas',
    changeBankAccountDesktop: 'Cambiar cuenta bancaria',
    postMail: 'correo postal',
    requestNotAvaiable: 'Solicitud no disponible',
    notPosibleFinishedRequest: 'No es posible completar tu petición porque ya hay una solicitud en curso.',
    call1551: 'Por favor, si no es así, ponte en contacto con nosotros en el 1551.',
    sessionExpired: 'Tu sesión ha caducado',
    sessionExpiredDescription: 'Tu sesión de usuario ha caducado o ya no es válida. Debes acceder de nuevo.',
    codeError: 'Código de error:',
    widgetConsumption: 'Widget consumo',
    goThroughWhatsapp: 'Continuar por WhatsApp',
    firstSteps: 'Primeros pasos',
    firstStepsDescription: 'Consulta los plazos y estados de los servicios contratados.',
    supportWhatsapp: 'Atención por WhatsApp',
    supportWhatsappDescription:
        'Escríbenos por Whastapp. Nuestro horario es de 9 h a 22 h, todos los días de la semana.',
    supportPhone: 'Atención por teléfono',
    supportPhoneDescription: 'Contacta con nosotros llamando gratis al 1551.',
    invoice: 'Facturas',
    downloadInvoices: 'Descarga tus facturas',
    downloadSuccessTitle: 'Descarga completada',
    downloadSuccessDescription: 'La descarga de tu selección de facturas ha sido completada.',
    downloadErrorTitle: 'Descarga no finalizada',
    downloadErrorDescription:
        'Lo sentimos, no hemos podido descargar las facturas seleccionadas.\n\nPor favor, inténtalo más tarde. \n\n\n',
    descriptionInvoice: 'Aquí podrás consultar y descargar tus facturas de los últimos 6 meses.',
    explore: 'Para ti',
    chatTabsProductCallout: 'Pulsa sobre la respuesta que más se ajuste a las preguntas que te iremos realizando.',
    descriptionEmptyExplore:
        'En este apartado te mostraremos todos nuestros productos para que puedas cambiar de tarifa o contratar otros servicios si lo necesitas.',
    descriptionContractedProducts: 'Desde esta sección podrás comprobar el estado de los servicios contratados.',
    stateListProducts: 'Aquí podrás ver el estado de tus servicios contratados.',
    contractedProducts: 'Servicios contratados',
    mobileLines: 'LÍNEAS MÓVILES',
    principalLine: 'Línea Principal',
    breadcrumbsPrincipalLine: 'Línea principal',
    principalLineMay: 'LÍNEA PRINCIPAL',
    additionalLineMay: 'LÍNEA ADICIONAL',
    mobileLineMay: 'LÍNEA MOVIL',
    additionalLine: 'Línea adicional',
    mobileData: 'DATOS',
    activationRequested: 'Activación solicitada',
    desactivationRequested: 'Desactivación solicitada',
    sharedData: 'Compartir datos',
    sharedDataRosco: 'DATOS COMPARTIDOS',
    o2TagActive: 'Activado',
    o2TagDisable: 'Pendiente de activar',
    sharedDataDetails: 'Datos compartidos',
    o2CloudTitle: 'O2 Cloud',
    disabled: 'Desactivado',
    activated: 'Activado',
    activation: 'Activación',
    restriction: 'restricción',
    deactivation: 'Desactivación',
    payment: 'Abono',
    blockingRequest: 'Bloqueo solicitado',
    unlockingRequest: 'Desbloqueo solicitado',
    request: 'Estamos procesando tu petición.',
    roaming: 'Roaming',
    roamingDescription: 'Configura tu línea para evitar cargos inesperados cuando viajas fuera de España.',
    calloutRoaming:
        'La activación y desactivación de estas restricciones pueden tardar unos minutos.\nCuando la restricción esté activa verás la opción en azul.',
    requestFeedback: '{{type}}',
    requestLoading: 'Estamos procesando tu petición',
    infoRequestFeedback: 'La {{type}} de {{context}} puede tardar unos minutos.',
    infoRequestFeedbackActiveRoaming: 'La activación de la restricción puede tardar unos minutos.',
    infoRequestFeedbackDesactiveRoaming: 'La desactivación de la restricción puede tardar unos minutos.',
    infoRequestFeedbackActiveNumber: 'La activación del bloqueo puede tardar unos minutos.',
    infoRequestFeedbackDesactiveNumber: 'La desactivación del bloqueo puede tardar unos minutos.',
    specialsNumber: 'Bloqueo de números especiales',
    specialsNumberDescription: 'Bloquea llamadas y mensajes a números especiales para evitar gastos inesperados.',
    blockLine: 'Bloqueo de línea por perdida o robo',
    unlockLine: 'Desbloqueo de línea por robo',
    blockLineDescription1: 'Al activar esta opción, la línea quedará bloqueada y no podrá utilizarse.',
    blockLineDescription2: 'Al activar esta opción se desbloqueará esta linea para realizar y recibir llamadas.',
    blockLineHeader: 'Bloquear línea por pérdida o robo',
    unlockLineHeader: 'Desbloqueo de línea',
    blockLineText1: 'Bloqueo de línea',
    blockLineCaptionTitle1: 'Bloquear la línea',
    blockLineCaptionTitle2: 'Desbloquear la línea',
    blockLineCaptionDescription1: 'Activa el bloqueo de línea para inhabilitar el servicio.',
    blockLineCaptionDescription2: 'Desactiva el bloqueo de línea para poder volver a utilizar el servicio.',
    blockLineFeedbackSuccessHeader: 'Solicitud  de bloqueo completada',
    blockLineFeedbackSuccessDescription:
        'Con este bloqueo no podrás llamar, recibir llamadas ni utilizar los datos móviles.\n\nSi quieres desbloquearla, puedes hacerlo accediendo al detalle de la línea.',
    unlockLineFeedbackSuccessHeader: 'Solicitud de desbloqueo completada',
    unlockLineFeedbackSuccessDescription: 'Tu línea ya tiene el servicio activo, puedes recibir y enviar llamadas.',
    blockMultiSimDialogMessage:
        'Actualmente tienes el servicio Multisim activo y no es posible realizar el bloqueo de tu línea.\n\nContacta con el 1551 para poder bloquear la línea.',
    blockedLine: 'Línea bloqueada',
    callDivert: 'Desvío de llamadas',
    callDivertDescription: 'Consulta cómo desviar tus llamadas entrantes al número que elijas.',
    calldivertalerttext1:
        'No es posible activar desvíos en tu línea móvil desde Mi O2, sólo comprobar si tienes alguno activo.',
    calldivertalerttext2:
        '​Si tienes más de un desvío y quieres cancelarlos todos marca en el teclado de tu terminal ##002# y la tecla llamada.​',
    calldivertalerttext3:
        'Si respondes a una llamada que está siendo desviada, se tarificará esa llamada en la línea en la que has aplicado el desvío.​',
    calldivertalerttextbtn: 'Entendido',
    duplicateSim: 'Solicitar duplicado SIM/eSIM',
    duplicateSimDescription: 'Solicita un duplicado para tu servicio de SIM y eSIM.',
    eSimQR: 'QR de instalación eSIM',
    eSimQRDescription: 'Visualiza el Qr de configuración.',
    multiSim: 'MultiSIM',
    multiSimRequest: 'Solicitar MultiSIM',
    activeMultiSim: 'Activar MultiSIM',
    activeMultiEsim: 'Activar Multi eSIM',
    installEsim: 'Instalar eSIM',
    installEsimDescription: 'Activa y gestiona tu eSIM',
    activateSim: 'Activar SIM',
    codepuk: 'Código PUK',
    codepukDescription: 'Este es el código de desbloqueo de la tarjeta SIM:',
    descriptionBlockedNumbersActivated:
        'Estamos procesando tu petición. \n\nLa activación del bloqueo puede tardar unos minutos.',
    descriptionBlockedNumbersDeactivated:
        'Estamos procesando tu petición. \n\nLa desactivación del bloqueo puede tardar unos minutos.',
    descriptionRoamingActivated:
        'Estamos procesando tu petición. \n\nLa activación de la restricción puede tardar unos minutos.',
    descriptionRoamingDeactivated:
        'Estamos procesando tu petición. \n\nLa desactivación de la restricción puede tardar unos minutos.',
    BlockedNumberAct: 'Para activarlo, ',
    BlockedNumberDesact: 'Para desactivarlo, ',
    BlockedNumberTitle1: 'Todas las llamadas',
    BlockedNumberdescription1: 'marca **21*nº de desvío# y pulsa la tecla de llamada.',
    BlockedNumberTitle2: 'Al comunicar',
    BlockedNumberdescription2: 'marca **67*nº de desvío# y pulsa la tecla de llamada.',
    BlockedNumberTitle3: 'Al no contestar',
    BlockedNumberdescription3: 'marca **61*nº de desvío# y pulsa la tecla de llamada',
    BlockedNumberTitle4: 'Apagado o fuera de cobertura',
    BlockedNumberdescription4: 'marca **62*nº de desvío# y pulsa la tecla de llamada.',
    mobileDataBonus: 'BONO DE DATOS',
    checkExtraBonus: 'Consultar bonos extra',
    otherServices: 'OTROS SERVICIOS',
    fiber: 'Fibra',
    day: 'días',
    billingClyce: 'CICLO DE FACTURACIÓN',
    billingCycleClose: 'FINALIZA EN',

    includesFee: '¿Qué incluye mi tarifa?',
    devicesFee: 'DISPOSITIVOS Y SERVICIO TÉCNICO',
    deviceTag: 'Dispositivo',
    consumptionInformation: 'Información de consumo',
    alertCycleEndedDescription:
        'El día 18 de cada mes, reiniciamos el contador de tu consumo. Por este motivo, puede ser que las cifras que te mostremos no sean exactas durante un breve periodo.\n\nDisculpa las molestias.',
    consumptionInformationDescription: 'Estamos reiniciando tu contador de consumos.',
    moreInformation: 'Más información',
    extraExpense: 'Gasto extra',
    moreGigsTitle: '¿Necesitas más gigas?',
    moreGigsDescription: 'Activa un bono extra de datos y navega a máxima velocidad.',
    moreGigsButton: 'Ver bonos',
    lineConfigurationTitle: 'Gestiona tu línea',
    lineConfigurationDescription: 'Puedes consultar y gestionar diferentes opciones de tu línea.',
    gigs: 'GB',
    bonds: 'BONO DE DATOS',
    extrabonds: 'BONOS EXTRA',
    calls: 'LLAMADAS',
    minutes: 'min',
    messages: 'MENSAJES',
    sms: 'SMS',
    unlimited: 'de ilimitados',
    unlimitedOnly: ' ilimitados',
    euro: '€',
    clyceDetails: 'Ciclo del',
    dataDetails: 'Datos',
    callsDetails: 'Llamadas',
    callsDetails2: 'llamadas',
    smsDetails: 'Mensajes',
    othersDetails: 'Otros',
    landLineCalls: 'LLAMADAS A FIJOS',
    mobileCalls: 'LLAMADAS A MÓVILES',
    consumptionDetailsHeader: 'CONSUMO',
    bonusSuccess:
        'Tu bono extra está procesándose.\n\nEn unos minutos te enviaremos un SMS de confirmación y lo verás activo en Mi O2.',
    bonusError:
        'Lo sentimos, no hemos podido activar tu bono.\n\nPor favor, inténtalo más tarde.\n\nSi el problema persiste, ponte en contacto con nosotros en el 1551.',
    extraBonusDetails: 'Con bono/s extra',
    extraExpenseDetailsHeader: 'GASTO EXTRA',
    titleDataDetails: 'No tienes ningún consumo de datos en este ciclo',
    descriptionDataDetails: 'Aquí podrás comprobar los gastos sobre tu servicio de datos.',
    titleOtherDetails: 'No tienes otros consumos en este ciclo',
    descriptionOtherDetails:
        'Aquí verás tu consumo realizado en servicios adicionales que no son llamadas, SMS ni datos.',
    titleCycleEndedEmptyState: 'Información no disponible',
    descriptionCycleEndedEmptyState:
        'El día 18 de cada mes, reiniciamos el contador de tu consumo. Por este motivo, en este momento no podemos mostrarte esta información.\n\nPodrás volver a consultarlo en las próximas horas.',
    titleCallsDetails: 'No has realizado ninguna llamada en este ciclo',
    descriptionCallsDetails: 'Aquí podrás comprobar los gastos asociados a tu servicio de llamadas.',
    titleSMSDetails: 'No has enviado ningún mensaje en este ciclo',
    descriptionSMSDetails: 'Aquí podrás comprobar los gastos asocidados a tus mensajes.',
    titleExtraExpense: 'No tienes consumo extra en este ciclo',
    descriptionExtraExpense:
        'Aquí verás tu consumo realizado en servicios adicionales que no son llamadas, SMS ni datos.',
    megabyte: 'MB',
    kb: 'kb',
    bonusExtraDescription: 'Estos son los bonos extra de datos que has activado durante este ciclo:',
    bonusExtraNoBonus: 'Esta línea no ha adquirido bonos en este ciclo.',
    fiberInformation: 'INFORMACIÓN SOBRE FIBRA',
    descentSpeedFiber: 'Velocidad de bajada',
    uploadSpeedFiber: 'Velocidad de subida',
    speedTestFiber: 'Test de velocidad',
    speedProblemsFiber: '¿Problemas con la velocidad de la fibra de O2? Información y consejos',
    noInternetRouterFiber: 'No funciona internet con el router de O2',
    networkBetterFiber: 'WiFi o WiFi Plus, ¿qué red es mejor para mí?',
    measureConnection: 'Mide la conexión de tu red móvil o fija',
    mobileDataConnectionTitle: 'Conexión de datos móviles',
    mobileDataConnectionDescription:
        'Para calcular la velocidad de tus datos móviles, asegúrate de no estar conectado a ninguna red WiFi.',
    wifiNetworkConnectionTitle: 'Conexión de red WiFi',
    wifiNetworkConnectionDescription:
        'Para calcular la velocidad de tu WiFi, asegúrate de estar conectado a la red que quieres medir.',
    btnCheckSpeed: 'Comprueba tu velocidad',
    informationAboutTest: 'Información sobre el test',
    closeOtherAppsTitle: 'Cierra otras aplicaciones',
    closeOtherAppsDescription: 'Durante el test, asegúrate de no tener otras aplicaciones abiertas.',
    mayInterestYou: 'TE PUEDE INTERESAR ',
    interpretTest: '¿Cómo interpretar este test?',
    yourConnectionIsSlow: '¿Tu conexión es lenta?',
    tipsToImproveConnection: 'Consejos para mejorar tu conexión',
    speedRiseInterpretTestDescription:
        'Es la velocidad para subir contenidos a la red, especialmente importante si usas internet para cargar fotografías, vídeos y todo tipo de archivos "pesados". ',
    loweredSpeedInterpretTest:
        'Es la velocidad con la que descargas contenido de internet. Consultar páginas web, correo electrónico, ver contenidos en streaming, bajar archivos... ',
    ipInterpretTestTitle: 'IP',
    ipInterpretTestDescription:
        'Es la dirección única e irrepetible que se asigna a cada dispositivo que trata de comunicarse en Internet. En el test de velocidad te indicamos la dirección IP que te hemos asignado, puede serte de utilidad si, por ejemplo, tienes que abrir los puertos en tu router.',
    pingInterpretTestTitle: 'Ping',
    pingInterpretTestDescription:
        'Se utiliza para medir el tiempo que tardan (latencia) en comunicarse dos puntos remotos, por tanto, cuanto más bajo sea este valor mejor será tu conexión. El ping se mide en milisegundos (ms), ya que esta medida se corresponde al tiempo que tarda en llegarte la respuesta de un servidor al que tú has solicitado algo. Lo general debería ser entre 20 y 50 para considerarlo como bueno.',
    jitterInterpretTestTitle: 'Jitter',
    jitterInterpretTestDescription:
        'Es el camino que puede seguir un paquete entre un mismo transmisor y receptor. Puede variar en función de ciertos parámetros. A causa de esto y de otros factores, el retardo que puede sufrir un paquete (latencia) en relación a otro enviado inmediatamente después, puede no ser el mismo. En condiciones óptimas debería ser inferior a 100 ms.',
    browserInterpretTestTitle: 'Navegador',
    browserInterpretTestDescription:
        'En este campo te indicaremos el navegador (Chrome, Safari, Firefox…) con el que has llevado a cabo la prueba. ',
    slowConnectionTitle:
        'Si tu conexión a internet no funciona correctamente pueden existir diversos motivos, te recomendamos llevar a cabo las siguientes comprobaciones: ',
    slowConnetionItemOneTitle: '1. Comprueba las conexiones',
    slowConnetionItemOneDescription:
        'Si no tienes línea de teléfono fijo, prueba a conectar el teléfono a otra roseta, si tampoco tienes línea, contacta con nosotros llamando al 1551 para que podamos revisarlo contigo. ',
    slowConnetionItemOneLink: 'Contactar con soporte técnico',
    slowConnetionItemTwoTitle: '2. Equipos WiFi',
    slowConnetionItemTwoDescription:
        'Si dispones de línea de teléfono y tienes acceso a internet en los equipos conectados por cable al router, entonces el problema lo tienes en la conexión a través de los equipos WiFi. ',
    slowConnetionItemTwoLink: 'Consejos para mejorar tu conexión',
    slowConnetionItemThreeTitle: '3. Comprueba que tienes luz',
    slowConnetionItemThreeDescription:
        'Aunque parezca obvio, conviene revisar si el router está desenchufado de la corriente o tenemos luz en nuestro domicilio. Además, también podemos tener un problema con el adaptador de corriente pese a estar correctamente enchufado. ',
    slowConnetionItemFourTitle: '4. Apagar y encender los equipos ',
    slowConnetionItemFourDescription: 'Siempre es recomendable reiniciar los equipos instalados (router, PC, ONT… ).',
    tipsToImproveConnectionTitle: '10 consejos para optimizar el rendimiento de tu conexión WiFi:',
    tipsOneToImproveConnectionTitle: '1. Empareja tus dispositivos',
    tipsOneToImproveConnectionDescription:
        'Introduce cuidadosamente los parámetros de conexión WiFi (identificador/SSID y contraseña) o bien por WPS.',
    tipsTwoToImproveConnectionTitle: '2. Coloca las antenas del router',
    tipsTwoToImproveConnectionDescription: 'Asegúrate de que están en ángulo recto o en posición de V.',
    tipsThreeToImproveConnectionTitle: '3. Coloca el router en posición elevada',
    tipsThreeToImproveConnectionDescription: 'No lo escondas y evita los obstáculos. ',
    tipsFourToImproveConnectionTitle: '4. Calidad del dispositivo que utilices',
    tipsFourToImproveConnectionDescription:
        'Esto afecta a la velocidad WiFi, un smartphone de alta gama garantiza más velocidad que un móvil antiguo.',
    tipsFiveToImproveConnectionTitle: '5. Conéctate por cable de red',
    tipsFiveToImproveConnectionDescription: 'El cable de red Ethernet ayuda a conseguir una mayor velocidad.',
    tipsSixToImproveConnectionTitle: '6. Distancia y cobertura del dispositivo ',
    tipsSixToImproveConnectionDescription:
        'Si el indicador de cobertura es bajo puede deberse a que existan otros elementos que perjudican la señal.',
    tipsSevenToImproveConnectionTitle: '7. Interferencias entre dispositivos',
    tipsSevenToImproveConnectionDescription:
        'Algunos dispositivos de tu hogar pueden crear interferencias en la red WiFi. Aléjalos del router o apágalos si no los necesitas.',
    tipsEightToImproveConnectionTitle: '8. Dispositivos conectados por WiFi',
    tipsEightToImproveConnectionDescription: 'Apágalos si no los estas usando para optimizar la conexión.',
    tipsNineToImproveConnectionTitle: '9. Conecta los equipos antiguos por cable',
    tipsNineToImproveConnectionDescription:
        'Los equipos antiguos conectador por WiFi bajan el rendimiento de la red en conjunto. ',
    tipsTenToImproveConnectionTitle: '10. Equipos de tus vecinos',
    tipsTenToImproveConnectionDescription: 'Pueden causar interferencias en tu red WiFi.',
    bondsAvailableTitle:
        'Elige el bono que quieres y pulsa en el botón Comprar para activarlo.\n\nPodrás disfrutar del bono hasta el día 17 por la noche, coincidiendo con el fin del ciclo de facturación.',
    totalTaxBuyBonds: 'Total (impuestos incl.)',
    buttonBuyBonds: 'Comprar',
    infoFeedbackScreenTitle: 'Estamos activando tu bono',
    infoFeedbackScreenDescription:
        'Tu bono extra está procesándose.\n\nEn unos minutos te enviaremos un SMS de confirmación y lo verás activo en Mi O2.',
    errorFeedbackScreenTitle: 'Bono extra no activado',
    errorFeedbackScreenDescription:
        'Lo sentimos, no hemos podido activar tu bono.\n\nPor favor, inténtalo más tarde.\n\nSi el problema persiste, ponte en contacto con nosotros en el 1551.',
    buttonUnderstoodFeedback: 'Entendido',
    refresh: 'Reintentar',
    modalExtraBonusTitle: 'Características del bono',
    modalExtraBonusLink: 'Mas información en la web',
    enableShareDataOneTitle: '¿En qué consiste este servicio?',
    enableShareDataOneDescription:
        'Con este servicio, todas las líneas móviles asociadas a tu fibra comenzarán a compartir sus datos entre ellas.\n\nLa activación no tiene coste y se renovará automáticamente cada mes.',
    enableShareDataTwoTitle: '¿Cuándo puedo activarlo?',
    enableShareDataTwoDescription:
        'Este servicio se puede activar solo una vez en cada ciclo de facturación.\n\nSi lo desactivas en mitad de un ciclo de facturación, no podrás volver a activarlo hasta el próximo ciclo.',
    enableShareBtnActivate: 'Activar',
    enableShareBtnDeactivate: 'Desactivar',

    enableSharedDataInfoFeedbackTitle: 'Solicitud enviada',
    enableSharedDataInfoFeedbackDescriptionActivate:
        'Estamos procesando tu petición para activar el servicio Compartir datos.\n\nTe enviaremos un SMS en las próximas horas para confirmarte la activación.',
    enableSharedDataErrorFeedbackTitleActivate: 'Servicio no activado',
    enableSharedDataErrorFeedbackDescriptionActivate:
        'Lo sentimos, no hemos podido activar el servicio Compartir datos.\n\nPor favor, inténtalo más tarde.\n\nSi el problema persiste, ponte en contacto con nosotros en el 1551.',
    feedbackCodeError: 'Código de error:',

    enableSharedDataInfoFeedbackDescriptionDeactivate:
        'Estamos procesando tu petición para desactivar el servicio Compartir datos.\n\nTe enviaremos un SMS en las próximas horas para confirmarte la desactivación.',
    enableSharedDataErrorFeedbackTitleDeactivate: 'Servicio no desactivado',
    enableSharedDataErrorFeedbackDescriptionDeactivate:
        'Lo sentimos, no hemos podido desactivar el servicio Compartir datos.\n\nPor favor, inténtalo más tarde.\n\nSi el problema persiste, ponte en contacto con nosotros en el 1551',
    dialogTitleSharedData: 'Solicitud no disponible',
    serviceNotAvaiable: 'Servicio no disponible',
    stopperDescription:
        'En este momento el servicio no está disponible por motivos de mantenimiento. Disculpa las molestias.',
    contentLoginTitle: 'Introduce tu número móvil de O2 y te enviaremos un código por SMS.',
    contentLoginInputLabel: 'Número de teléfono',
    contentLoginButton: 'Acceder',
    contentModalHelpWithAccessTitle:
        'A continuación, puedes elegir entre registrarte, si es tu primera vez en Mi O2, u obtener información sobre las formas de acceder.',
    contentModalLoginInformation: 'INFORMACIÓN SOBRE INICIO DE SESIÓN',
    contentModalLoginInformationRowOne: 'Es mi primera vez, ¿cómo me registro?',
    contentModalLoginInformationRowTwo: 'Formas de acceder',
    contentModalHelpWithAccessTitleCard: 'Contacta con O2',
    contentModalHelpWithAccessSubtitleCard:
        'Si necesitas obtener más información o deseas contactar directamente con nosotros.',
    contentModalHelpWithAccessBtnCard: 'Llamar al 1551',
    titleModalToAccess: 'Formas de acceder',
    titleModalToSignUp: 'Regístrate en Mi O2',
    contentModalSignUp:
        'Si es tu primera vez en Mi O2, sigue estos pasos para obtener tus datos de acceso:\n\n1. Escribe el documento del titular(NIF, CIF o NIE), incluyendo números y letras sin espacios. Así: 01234567Z.\n2. Introduce el número móvil del titular.\n3. Te enviaremos un SMS con un código de seguridad que tendrás que usar para elegir tu contraseña.\n4. Vuelve a la pantalla de inicio e introduce el documento del titular y la contraseña.\n\nSi no cierras sesión, las próximas veces no tendrás que volver a introducir los datos de acceso.',
    contentModalSingUpaccessWithPassword: 'Accede con contraseña',
    contentModalSingUpaccessWithPasswordText:
        'Para iniciar sesión, tendrás que introducir el documento del titular (NIF, CIF o NIE) y tu contraseña.',
    contentModalSingUpaccessWithMobile: 'Accede con tu móvil',
    contentModalSingUpaccessWithMobileText:
        'Introduce tu número móvil de O2 y te enviaremos un SMS con un código que tendrás que introducir para iniciar sesión.\n\nPor seguridad, con esta forma de acceso solo podrás ver el detalle de esa línea. Para ver las demás, tendrás que acceder con el documento del titular y la contraseña.',
    fiberAndMobileBill: 'Fibra y móvil',
    mobileLineBill: 'Línea móvil',
    onlyFiber: 'Solo fibra',
    emptyStateNoListBillTitle: 'Este mes no tienes facturas disponibles',
    emptyStateNoListBillDescription: 'Recuerda que puedan tardar hasta 24h en aparecer en la aplicación.',
    rangeSelection: 'Selecciona un periodo',
    rangeSelected: 'Últimos meses',
    billNumbre: 'Factura n.º',
    emptyStateNoBillDetailTitle: 'Ya está disponible tu factura',
    billPendingPayment: 'Pendiente de pago',
    billDetailDownloadButton: 'Descargar',
    billDetailSendButton: 'Enviar',
    billDetailCalloutDescription: 'Factura pendiente de pago.',
    billDateTitle: 'Factura de',
    billDateDescription: 'Emitida el',
    calloutBillOutstanding:
        'En este momento tienes facturas pendientes. Pulsa en "Revisar" para realizar el pago. Si ya lo has hecho, pulsa en "Refrescar" y dejarás de ver este aviso.',
    calloutButtonPrimaryBillOutstanding: 'Revisar',
    calloutButtonLinkPrimaryBillOutstanding: 'Refrescar',
    modalDebtPaymentTitle: 'Este es el importe de las facturas pendientes:',
    modalDebtPaymentSubtitle: 'Para revisarlas y realizar el pago, elige el producto que deseas gestionar:',
    modalDebtPaymentTotalDebt: 'Deuda total',
    modalDebtPaymentDebtCalloutTitle: 'Rehabilitación de líneas',
    modalDebtPaymentDebtCalloutDescription: 'Reactiva tus líneas de forma temporal y paga en las próximas 48 horas.',
    bills02: 'FACTURA02_',
    modalDebtPaymentBillsSeleccionTitle: 'Selecciona las facturas que quieres pagar:',
    modalDebtPaymentGoToPaymentButton: 'Ir al pago',
    modalDebtPaymentTextLinkSeeBill: 'Ver detalle de factura',
    modalRehabilitationLinesTitle:
        'Si lo necesitas, puedes reactivar tus líneas temporalmente y realizar el pago en las próximas 48h.​\n\nPuedes hacerlo a través de los siguientes canales:​',
    modalDebtPaymentFeedbackTitle: 'No tienes facturas pendientes',
    modalDebtPaymentFeedbackDescription:
        'Si ya has realizado el pago de las facturas pendientes, pulsa Refrescar en la pantalla Facturas y dejarás de ver el aviso.',
    modalRehabilitationLinesButtonFooter: 'Rehabilitar líneas',
    modalRehabilitationLinesRowOne: 'Con tarjeta de crédito/débito ',
    modalRehabilitationLinesRowOneText: 'desde la app Mi O2 o desde nuestra web accediendo al apartado "Soy cliente".​',
    modalRehabilitationLinesRowTwo: 'Llamando al 1551.',
    modalRehabilitationLinesRowThree:
        'Presentando el documento recibido por <i>{{postMail}}</i> en una de las siguientes entidades:​',
    modalRehabilitationLinesRowThreeText:
        ' en una entidad colaboradora, presentando el documento recibido por correo postal.\n • Banco Santander\n • BBVA\n • Oficinas de Correos',
    rehabilitationLinesInfoFeedbackTitle: 'Solicitud realizada',
    rehabilitationLinesInfoFeedbackDescription:
        'Vamos a proceder a rehabilitar tu línea.\n\nRecuerda que debes pagar el importe pendiente en las próximas 48h en alguno de los canales habilitados.\n\nTe vamos a enviar un email con información importante acerca de esta solicitud.',
    titleSharedDataDetails: 'CONSUMO DE DATOS POR LÍNEA MÓVIL',
    rateSharedDataDetails: 'Tarifa ',
    deliveryAddress: 'Dirección de envío',
    email: 'Correo electrónico',
    mobileLine: 'Línea móvil',
    serviceCost: 'Coste del servicio',
    debtPaymentModalHeader: 'Pago de deuda',
    personalDataTitle: 'DATOS DE CONTACTO',
    personalDataMobile: 'Móvil de contacto',
    personalDataEmail: 'Dirección de email',
    personalDataAccount: 'DATOS BANCARIOS',
    personalDataBankAccount: 'Cuenta bancaria',
    personalDataAddMobile: 'Añadir móvil',
    personalDataAddMobileDesktop: 'Añadir móvil de contacto',
    personalDataAddEmailDesktop: 'Añadir dirección de email',
    personalDataAddEmail: 'Añadir dirección',
    personalDataAddMobileText: 'Introduce tu móvil de contacto:',
    personalDataAddEmailText: 'Introduce tu dirección de email:',
    personalDataChangeMobileText1: 'Este es tu móvil de contacto:',
    personalDataChangeEmailText1: 'Esta es tu dirección de email actual:',
    personalDataChangeMobileText2: 'Si quieres cambiarlo, introduce aquí el nuevo:',
    personalDataChangeEmailText2: 'Si quieres cambiarla, introduce aquí la nueva:',
    personalDataNewEmail: 'Nueva dirección de email',
    personalDataNewContactPhone: 'Nuevo móvil de contacto',
    personalDataHelperTextMobile: 'El formato debe ser XXX XXX XXX',
    personalDataHelperTextEmail: 'El formato debe ser ejemplo@mail.com',
    personalDataCalloutMobile:
        'Utilizaremos tu móvil de contacto para comunicarte información importante sobre tu servicio. Nunca para molestarte o con fines comerciales.',
    personalDataCalloutEmail:
        'Utilizaremos tu dirección de email para enviarte información importante sobre tu servicio. Nunca para molestarte o con fines comerciales.',
    wizinkCardTitle: 'WiZink Center',
    wizinkCardDescription: 'Con tu código QR tendrás ventajas por ser cliente de O2',
    btnQr: 'Acceder al QR',
    profileAddMobileFeedbackSuccessTitle: 'Número guardado',
    profileAddMobileFeedbackSuccessSubtitle: 'Tu móvil de contacto se ha guardado correctamente.',
    profileFeedbackErrorTitle: 'Ha ocurrido un error',
    textErrorObd57:
        'Hemos detectado que el documento no coincide con el titular de la línea.\n\nPara poder verificar los medios de contacto, debes ser el titular.',
    textErrorObdGeneric:
        'La validación no ha podido completarse.\n\nPor favor, revisa que los datos facilitados sean correctos. Si el problema persiste, inténtalo de nuevo más tarde.',
    profileFeedbackErrorSubtitle:
        'Lo sentimos. Por motivos técnicos no se ha podido completar tu solicitud.\n\nPor favor, inténtalo de nuevo más tarde.',
    profileAddEmailFeedbackSuccessTitle: 'Email guardado',
    profileAddEmailFeedbackSuccessSubtitle:
        'Tu dirección de email se ha guardado correctamente.\n\nTe vamos a enviar un email para confirmártelo.',
    profileChangeMobileFeedbackSuccessTitle: 'Cambio realizado',
    profileChangeMobileFeedbackSuccessSubtitle: 'Tu móvil de contacto se ha modificado correctamente.',
    profileChangeEmailFeedbackSuccessTitle: 'Cambio realizado',
    profileChangeEmailFeedbackSuccessSubtitle: 'Tu dirección de email se ha modificado correctamente.',
    profileHighlightedCardTitle: 'Ventajas en WiZink Center',
    profileHighlightedCardDescription:
        'Muestra tu código QR en el recinto para conseguir tus ventajas como cliente de O2.',
    profileNotifications: 'Notificaciones',
    profileWidget: 'Widget',
    profilePersonalInformation: 'Datos personales',
    profileOrders: 'Pedidos',
    profileAccessWithBiometrics: 'Acceso con biometría',
    profileChangePassword: 'Cambio de contraseña',
    profileRateApp: 'Valorar la app',
    profileSignOff: 'Cerrar sesión',
    ordersTagInitiated: 'Iniciado',
    ordersTagPending: 'Pendiente',
    ordersState: 'Solicitado',
    ordersTagInProgress: 'En curso',
    ordersTagCancelled: 'Cancelado',
    ordersTagDone: 'Realizado',
    ordersTagFinished: 'Finalizado',
    ordersTagIncidence: 'Incidencia',
    ordersEmptyStateTitle: 'No existe ningún pedido',
    ordersEmptyStateDescription: 'Cuando realices un pedido podrás consultar aquí el estado del mismo.',
    orderTrackingContentTracing: 'SEGUIMIENTO',
    checkDebtTitle: 'No tienes facturas pendientes',
    checkDebtSubtitle:
        'Si ya has realizado el pago de las facturas pendientes, pulsa Refrescar en la pantalla Facturas y dejarás de ver el aviso.',
    changesPasswordTitle: 'Introduce la nueva contraseña:',
    changesPasswordNewPassword: 'Nueva contraseña',
    changesPasswordHelperTextInfo: 'La contraseña debe tener entre 8 y 20 caracteres y puedes usar números y/o letras.',
    save: 'Guardar',
    install: 'Instalar',
    duplicate: 'Duplicado',
    downloading: 'Descargando',
    changesPasswordInfoFeedbackTitle: 'Cambio realizado',
    changesPasswordInfoFeedbackDescription:
        'Tu contraseña se ha modificado correctamente.\nTendrás que iniciar sesión con tu nueva contraseña.',
    changesPasswordInfoFeedbackErrorDescription:
        'Lo sentimos. Por motivos técnicos no se ha podido completar tu solicitud de incidencia.\n\nPor favor, inténtalo de nuevo en unos minutos.',
    changesPasswordErrorFeedbackButton: 'Volver',
    orderDetail: 'Detalle de pedido',
    stateInstallation: 'Instalación',
    date: 'Cita',
    installationAddress: 'Dirección de instalación',
    telephoneContact: 'Teléfono de contacto',
    Shipping: 'Envío',
    shippingDate: 'Fecha de envío',
    locateShipment: 'Localizar este envío',
    unscheduledTagSecondary: 'Pendiente de agendar',
    scheduledTagSecondary: 'Agendada',
    doneTagSecondary: 'Realizada',
    expiredTagSecondary: 'Reprogramar cita',
    pendingTagSecondary: 'Iniciado',
    transitTagSecondary: 'En preparación',
    deliveryTagSecondary: 'En reparto',
    deliveredTagSecondary: 'Entregado',
    incidenceTagSecondary: 'Incidencia',
    finishNoDeliveredTagSecondary: 'Entrega fallida',
    modalSignOffTitle: '¿Quieres cerrar sesión?',
    modalSingOffDescription: 'Para entrar de nuevo en Mi O2 tendrás que introducir tu datos de acceso.',
    returnResponsive: 'Volver',
    returnConfigureLine: 'Configurar línea',
    lineManagement: 'Gestiona tu línea',
    returnBonusExtra: 'Bonos extra',
    returnExtraExpenseDetail: 'Detalle de gasto extra',
    returnBonusAvailable: 'Bonos disponibles',
    breadcrumbsHome: 'Inicio',
    breadcrumbsSupport: 'Soporte',
    breadcrumbsConfigureLine: 'Configuración línea',
    goodMorning: 'Buenos días',
    goodEvening: 'Buenas tardes',
    goodNight: 'Buenas noches',
    returnDetailConsumption: 'Detalle de consumo',
    next: 'Siguiente',
    profileChangeBankAccountText1: 'Selecciona la cuenta bancaria que quieres cambiar: ',
    profileChangeBankAccountText2: 'Al realizar el cambio, la cuenta se modificará para las siguientes líneas: ',
    previous: 'Anterior',
    profileChangeBankAccountText3: 'Introduce el nuevo número de cuenta:',
    profileChangeBankAccountHelperText: 'El formato debe ser ESXX CCCC CCCC CC CCCCCCCCCC',
    profileChangeBankAccountLabel: 'Nuevo número de cuenta (IBAN)',
    last4charactersText: 'Cuenta terminada en *',
    titleFeedbackSuccessBankAccount: 'Solicitud realizada',
    descriptionFeedbackSuccsessBankAccount:
        'Tu solicitud se ha registrado correctamente.\n\nSi has solicitado el cambio antes del día 17 del mes en curso, tu siguiente factura se cobrará en la nueva cuenta en los primeros días del próximo mes.\n\nSi es a partir del 18, el siguiente cobro se realizará en la cuenta anterior. Y a partir de ahí, se cobrará en la nueva.',
    devices: 'Dispositivos y servicio técnico',
    devicesExplore: 'Dispositivos',
    yourPlan: 'TU PLAN',
    devicesHiringText: 'CONTRATACIÓN',
    devicesFeeText: 'CUOTA',
    devicesInitialText: 'Inicio',
    devicesEndText: 'Fin',
    devicesMensualPriceText: 'Precio mensual',
    devicesNumberFeeText: 'Nº de cuotas',
    devicesButtonConditions: 'Ver condiciones',
    devicesBoxedRowTitle: 'Reparación de dispositivos',
    devicesBoxedRowSubtitle: 'Accede al servicio de reparación para tus dispositivos O2.',
    device: 'Dispositivo',
    billsEmptyStateNotAvaiableTitle: 'Este mes no tienes facturas disponibles',
    billsNoSpentDesc: 'Este mes no tiene gastos',
    billsMonthDesc: 'Total facturado en ',
    billsEmptyStateNotAvaiableDescription: 'Recuerda que puedan tardar hasta 24h en aparecer en la aplicación.',
    billsEmptyStateNoBillsTitle: 'Aún no tienes facturas disponibles',
    billsEmptyStateNoBillsDescription: 'Podrás consultar tu primera factura el próximo mes.',
    billsDebtSupportTitle: 'Ayuda',
    billsDebtSupportDescription: 'Consulta cualquier duda sobre tus facturas.',
    billsDebtWhatsappTitle: 'Whatsapp',
    billsDebtWhatsappDescription: 'Escríbenos si tienes dudas sobre tu factura.',
    billsSelected: 'facturas seleccionadas',
    billsMultipleSelection: 'Seleccionar varias',
    billsAllSelection: 'Seleccionar todo',
    billsDownloadSelection: 'Descargar selección',
    billIssueDate: 'Factura emitida el',
    billsDownloadingTitle1: 'Tus facturas se están descargando',
    billsDownloadingTitle2: 'La descarga se ha completado',
    billsDownloadingSubTitle1: 'El proceso puede tardar unos segundos',
    billsDownloadingSubTitle2: 'Ahora puedes guardar tus facturas',
    billsDownloadingSubTitle3:
        'Ya puedes descargar las facturas disponibles. Por favor intenta descargar el resto más tarde.',
    //Onboarding screen
    onboardingFirstVerTitle: 'Verificación segura',
    onboardingFirstVerSubtitle:
        'Para proteger tu seguridad, antes de continuar con la gestión, es necesario realizar un proceso de verificación que incluye los siguientes pasos:',
    onboardingFirstVerButton: 'Empezar',
    contactInfoVerificationTitle: 'Verificar datos de contacto',
    contactInfoVerificationSubtitle:
        'Por tu seguridad, es necesario que verifiques tu email y tu teléfono de contacto. Si quieres, podrás cambiarlos o verificar otros medios. Lo utilizaremos para: ',
    contactInfoVerification1: 'Ponernos en contacto contigo en relación a tu servicio.',
    contactInfoVerification2: 'Firmar tus contratos.',
    contactInfoVerification3: 'Identificarte y saber que eres tú.',
    contactInfoVerification4: 'Realizar gestiones sobre tu servicio.',
    contactVerificationStep1Title: 'Verifica tus datos de contacto.',
    contactVerificationStep1Subtitle:
        'En el caso de querer modificarlos, pulsa sobre el botón “Editar” e introduce un nuevo medio de contacto.',
    contactVerificationStep1Verified: 'Verificado',
    contactVerificationStep1NotVerified: 'No verificado',
    contactVerificationStep1MobileText: 'Móvil de contacto',
    contactVerificationStep1EmailText: 'Dirección de email',
    contactVerificationStep1ButtonVerify: 'Verificar',
    contactVerificationStep1ButtonEdit: 'Editar',
    contactVerificationStep1Callout:
        'Para actualizar un medio de contacto recientemente modificado pulsa en "Refrescar".',
    contactVerificationStep1CalloutButton: 'Refrescar',
    continue: 'Continuar',
    contactVerificationOTPtitle: 'Introduce el código de verificación que has recibido.',
    contactVerificationOTPsubtitle1: 'Te hemos enviado un código de verificación al email ',
    contactVerificationOTPsubtitle1Mobile: 'Te hemos enviado un código de verificación al teléfono ',
    contactVerificationOTPsubtitle2: ' para asegurarnos de que es el correcto.',
    contactVerificationOTPhelperTextError: 'Código introducido erróneo',
    contactVerificationOTPLink: '¿No has recibido el código?',
    contactVerificationSuccessTitle: 'Solicitud completada',
    feedbackSuccessSubtitle: 'Tu petición se ha realizado correctamente',
    contactVerificationSuccessSubtitle: 'Tu medio de contacto se ha verificado correctamente.',
    contactVerificationsSuccessSubtitle: 'Tus medios de contacto se han verificado correctamente.',
    identity_check: 'Verificación de identidad',
    identity_check_explain:
        'Registraremos tus datos de reconocimiento y tu documento de identidad. Así sabremos que eres tú.',
    contact_media_verification: 'Verificación de medios de contacto',
    contact_media_verification_explain: 'Validaremos tu email y/o teléfono enviándote un código de seguridad.',
    verification_secure: 'Verificación segura',
    verification_secure_explain:
        'Para proteger tu seguridad, antes de continuar con la gestión, es necesario realizar un proceso de verificación que incluye los siguientes pasos:',
    verification_important_information: 'Información importante',
    verification_important_information_explain_text1:
        'Solo utilizaremos los datos que nos facilites para verificar tu identidad. \n\nComo cliente de O2, puedes ejercer los derechos que te confiere la normativa de protección de datos en nuestra web.',
    got_it: 'Entendido',
    contacVerifiedTitle: 'Elige un medio de contacto para realizar la operación de forma segura.',
    contactVerifiedCallout:
        'Si necesitas cambiar los medios de contacto, puedes hacerlo desde Perfil > Datos personales.',
    contactVerifiedTitleStep1: 'Verificación de datos',
    contactVerifiedTitleContact: 'Verificar móvil de contacto',
    contactVerifiedTitleEmail: 'Verificar email de contacto',
    contactVerifiedMobile:
        'Te vamos a enviar un código a tu número de contacto para asegurarnos de que la operación se realiza de forma segura.',
    contactVerifiedEmail:
        'Te vamos a enviar un código de verificación a tu email para asegurarnos de que la operación se realiza de forma segura.',
    contactVerifiedOTP: 'Introduce el código de verificación que has recibido.',
    supportContentTitle: '¿Algo no va bien?',
    supportContentRowSolveIncidentTitle: 'Resuelve tu incidencia',
    supportContentRowSolveIncidentDescription:
        'Soluciona el problema que tengas relacionado con tu línea o con tu servicio de fibra.',
    supportContentRowQueryIncidenceTitle: 'Histórico de incidencias',
    supportContentRowQueryIncidenceTagInactive: 'No tienes incidencias abiertas',
    supportContentRowQueryIncidenceTagWarning: 'Tienes incidencias abiertas',
    returnSupportIncidents: 'Tus incidencias',
    supportEmailTitleSnapcard: 'Email',
    supportHelpTitleBoxedRow: 'Ayuda e información de O2',
    supportHelpSubTitleBoxedRow: 'Resuelve tus dudas sobre O2 en nuestra web.',
    returnsupportIncidentDetail: 'Detalle de incidencia',
    supportIncidentsCreationDate: 'Fecha de creación',
    supportIncidentsEndDate: 'Fecha de fin',
    supportIncidentNumber: 'Nº:',
    supportErrorProblemsTitle: 'Algo ha fallado',
    supportIssueResolve: '¿Tu incidencia ha quedado resuelta?',
    supportWarningCall:
        'El problema indicado no se puede resolver online. Por favor, ponte en contacto con nosotros por WhatsApp y te ayudaremos.',
    supportWarningInactivity:
        'Ha transcurrido el tiempo máxima de espera. Si tu problema persiste, retoma la incidencia, por favor.',
    supportErrorProblemsDescription:
        'Lo sentimos, en este momento no podemos mostrarte esta información. Vuelve a intentarlo más tarde.',
    supportSuccessFeedbackTitle: 'Incidencia resuelta',
    supportSuccessFeedbackDescription:
        'Tu incidencia ha sido resuelta.\n\nSi detectas que algo no funciona correctamente, contacta con nosotros llamando al 1551.',
    supportSuccessFeedbackButton: 'Volver a soporte',
    supportDateTechnical: 'Cita técnica concertada el día',
    supportInfoFeedbackButton: 'Ir a tus incidencias',
    supportInfoFeedbackPendingIncidentTitle: 'Incidencia pendiente',
    supportInfoFeedbackPendingIncidentDescription:
        'Puedes continuar con las pruebas contactando con nosotros a través de WhatsApp. Si no puedes en este momento, podrás hacerlo más tarde desde la sección Soporte > Consulta tus incidencias.',
    supportInfoFeedbackReviewIncidenTitle: 'Estamos revisando tu incidencia',
    supportInfoFeedbackReviewIncidentDescription:
        'Si tu incidencia no ha quedado resuelta, por favor, ponte en contacto con nosotros llamando al 1551 y te ayudaremos.',
    supportInfoFeedbackReviewTechnicalIncidentDescription:
        'Vamos a revisar tu incidencia para poder darte una solución lo antes posible.\n\nNos pondremos en contacto contigo en el teléfono móvil que has facilitado.\n\nGracias',
    supportInfoFeedbackShipmentPendingIncidentDescription:
        'Estamos gestionando el envío de tu nuevo equipo a tu domicilio.\n\nRecuerda que un mensajero se encargará de entregártelo.\n\nSentimos las molestias.',
    supportInfoFeedbackExistsIncidentTitle: 'Ya existe una incidencia previa',
    supportInfoFeedbackExistsIncidentDescription:
        'Has abierto recientemente una incidencia similar. Si el problema aún no está resuelto, tienes 48 horas para reabrirla.',
    supportInfoFeedbackInProgressIncidentTitle: 'Incidencia en curso',
    supportInfoFeedbackInProgressIncidentDescription:
        'Has reabierto tu incidencia.\nVamos a revisar el problema de nuevo y, si es necesario, un técnico contactará contigo lo antes posible en el teléfono móvil facilitado.',
    supportInfoFeedbackCanceledIncidentTitle: 'Incidencia anulada',
    supportInfoFeedbackCanceledIncidentDescription:
        'Has anulado la incidencia.\n\nPuedes volver a abrir una nueva incidencia cuando lo necesites.\n',
    supportErrorFeedbackErrorOccurredTitle: 'Ha ocurrido un error',
    supportErrorFeedbackErrorOccurredDescription:
        'Lo sentimos. Por motivos técnicos no se ha podido completar tu solicitud de incidencia.\n\nPor favor, inténtalo de nuevo más tarde.',
    supportErrorMasiveFeedbackFailedTitle: 'Incidencia masiva',
    supportErrorMasiveFeedbackFailedDescription:
        'En estos momentos tenemos una incidencia masiva que afecta a todo el servicio en tu zona. Estamos trabajando para solucionar el problema lo antes posible.\n\nSentimos las molestias.',
    supportErrorFeedbackFailedTitle: 'Algo ha fallado',
    supportErrorFeedbackFailedDescription:
        'En este momento no podemos mostrarte esta información por problemas técnicos. Por favor, inténtalo de nuevo más tarde.',
    supportErrorFeedbackFailedConnectionDescription:
        'En este momento navegas más lento porque has agotado los datos incluidos en tu tarifa. Si quieres volver a nevagar a máxima velocidad, puedes comprar un bono extra de datos.',
    supportErrorDiagnosisFeedbackFailedDescription:
        'Lo sentimos. Por motivos técnicos, no es posible completar tu solicitud de incidencia.\n\nPor favor, ponte en contacto con nosotros llamando al 1551 y te ayudaremos.',
    supportChatAnswerTabProduct: '¿Sobre qué servicio quieres crear una incidencia?',
    supportChatTooltipTabProduct:
        'Pulsa sobre la respuesta que más se ajuste a las preguntas que te iremos realizando.',
    supportChatMotiveProblemAnswer: '¿Dónde crees que está el problema?',
    supportChatSameContactTitle: 'Ya existe ese número de teléfono',
    supportChatSameContact:
        'El número introducido es el mismo que te hemos propuesto. Por favor, si quieres utilizar ese teléfono de contacto selecciónalo en la conversación.',
    supportChatIncidentContactNumberAnswer:
        'Se van a realizar una serie de comprobaciones para resolver tu problema. En caso de que no sea posible resolverlo, un técnico contactará contigo en el número de teléfono que indiques a continuación.',
    profileAgreementTitle: 'Consentimiento de uso datos de reconocimiento',
    profileAgreementSubtitle:
        '¿Podemos utilizar los datos de reconocimiento recogidos en el proceso de verificación para mejorar tu experiencia de validación en O2?',
    profileAgreementButtonLink: 'Más información',
    profileAgreementButtonYes: 'Sí, consiento',
    profileAgreementButtonNo: 'No, gracias',
    profileAgreementAlertTitle: 'Datos de reconocimiento',
    profileAgreementAlertSubtitle:
        'Seleccionando esta opción, das tu consentimiento expreso para que O2 pueda almacenar tus datos de reconocimiento con el fin de verificar tu identidad antes de realizar gestiones que requieran una seguridad especial.',
    supportResponseChatTabsProductsFijo: 'No me funciona el fijo',
    supportResponseChatTabsProductsFibra: 'No me funciona internet en casa',
    supportResponseChatTabsProductsMovil: 'No me funciona el móvil',
    supportAnswerChatNumbers: 'Por favor, pulsa sobre tu línea para comenzar.',
    titleCustomerAgreements: 'Datos de reconocimiento',
    titleContactInfoVerification: 'Verificar datos de contacto',
    titleMobileVerification: 'Verificar móvil de contacto',
    titleEmailVerification: 'Verificar dirección de email',
    titleMobileChange: 'Cambiar móvil de contacto',
    titleEmailChange: 'Cambiar dirección de email',
    supportChatNewContactPhoneAnswer:
        'Se van a realizar una serie de comprobaciones para resolver tu problema. En caso de que no sea posible resolverlo, un técnico contactará contigo en el número de teléfono que indiques a continuación.',
    supportExampleChatNewContactPhone: 'Ejemplo: 6XX XXX XXX.',
    supportExampleChatNewContactPhoneError:
        'Ejemplo: 6XX XXX XXX.\n Por favor, introduce un número móvil o fijo nacional',
    supportChatChecksAnswer: 'Espera unos segundos mientras se realizan las comprobaciones.',
    supportChatChecksWritteNumber: 'Indicar otro teléfono',
    supportIncidentDetailBtnReturn: 'Retomar',
    supportIncidentDetailBtnCancel: 'Anular',
    supportIncidentDetailModalCancelTitle: '¿Quieres anular la incidencia?',
    supportIncidentDetailModalCancelDescription: 'Podrás volver a abrir una nueva incidencia cuando lo necesites.',
    supportTagIncidentsResolved: 'Resuelta',
    supportTagIncidentsFinished: 'Finalizada',
    supportTagIncidentsCancelled: 'Cancelada',
    supportTagIncidentsClosed: 'Cerrada',
    supportIncidentDetailCalloutTitle: 'Reabrir incidencia',
    supportIncidentDetailCalloutPendingDescription:
        'No es posible continuar con las comprobaciones online. Puedes continuar con la apertura de tu incidencia contactando con nosotros a través de WhatsApp. ',
    supportIncidentDetailCalloutDescription: 'Si no ha quedado conforme, contacta con nosotros a través del 1551.',
    supportEmptyStateNoIncidentTitle: 'No existe ningun incidencia',
    supportEmptyStateNoIncidentDescription: 'Cuando abras una incidencia podrás consultar aquí el estado de la misma.',
    exploreBoxedRowTagRatesTitle: 'Tarifas O2',
    exploreBoxedRowRatesDescription: 'Cambia de tarifa o contrata nuevos productos si necesitas.',
    exploreBoxedRowTagMobilesTitle: 'Teléfono móvil',
    exploreBoxedRowMobilesTitle: 'Teléfonos móviles',
    exploreBoxedRowMobilesDescription: 'Puedes añadir un dispositivo a tu tarifa de O2.',
    profileHeadline: 'Titular',
    profileNoHeadlineIsLight: 'Acceso: Usuario línea móvil',
    profileVersion: 'VERSION',
    errorGenericDescription:
        'En este momento Mi O2 está experimentando problemas técnicos. Por favor inténtalo más tarde, estamos trabajando para solucionarlo cuanto antes.',
    error401: 'Tu sesión de usuario ha caducado o ya no es válida. Debes acceder de nuevo.',
    error403: 'Tu sesión de usuario ha caducado o ya no es válida. Debes acceder de nuevo.',
    error410:
        'No puedes acceder a la app porque tu versión actual está desactualizada.\n\n Por favor, ve a tu app store para instalar la última versión.',
    profileTitle: 'Perfil',
    titleDesktopBillListOne: 'Tu factura de',
    titleDesktopBillListTwo: 'incluye:',
    billsCalloutDesktopBillsOK: 'Todas tus facturas están al día.',
    profileCardObdTagVerified: 'Verificado',
    profileCardObdTagNotVerified: 'No verificado',
    profileCardObdTitleVerified: 'Consulta tus datos verificados',
    profileCardObdTitleNotVerified: 'Verifica tus medios de contacto',
    profileCardObdSubtitleNotVerified:
        'Para realizar tus gestiones de forma ágil y segura, es importante que verifiques tus medios de contacto.',
    profileCardObdSubtitleVerified: 'Accede a tus datos personales para comprobar qué datos están verificados.',
    otpFlowTitle: 'Confirma tu identidad',
    otpFlowSubtitle:
        'Por motivos de seguridad, necesitamos confirmar tu identidad. Para ello, debes elegir un medio de contacto y, posteriormente, te enviaremos un código de verificación con el que podrás realizar la operación de forma segura.',
    visitO2webText: 'Visitar web de O2',
    agreementTitle: 'Datos de reconocimiento',
    cardContractingDeviceTitle: 'O2 Cloud y más',
    cardContractingDeviceDescription: 'Conoce más de O2: 500GB gratis en la nube, dispositivos y tarifas',
    cardContractingDeviceButton: 'Entrar',
    modifyAppointment: 'Modificar cita',
    chooseInstallationDate: 'Elige la fecha para la instalación de tu fibra:',
    seeMoreSchedules: 'Ver más horarios',
    descriptionCalloutModifyAppointmentMobile:
        'Si ninguna de las fechas disponibles se adapta a tus preferencias contáctanos.',
    descriptionCalloutModifyAppointmentDesktop:
        'Si ninguna de las fechas disponibles se adapta a tus preferencias, contacta a través de nuestro teléfono 1551.',
    cancelFiberInstallationAppointment: 'Anular cita',
    confirmCancelAppointment: '¿Seguro que quieres anular tu cita?',
    titleEmptyStateNoDate: 'No hay más horarios disponibles',
    descriptionEmptyStateNoDate: 'En este momento no hay más horarios disponibles para agendar tu cita.',
    availableTimes: 'Horarios Disponibles:',
    confirmDate: 'Confirmar cita',
    location: 'Ubicación',
    contactNumber: 'Número de contacto',
    confirmAppointmentData: 'Por favor, revisa los datos de tu nueva cita:',
    yourNumber: 'Este es tu número de teléfono:',
    newContactNumberRequestCall: 'Si prefieres que te llamemos a otro número, introdúcelo a continuación:',
    phone: 'Teléfono',
    weWillContactYou: 'Contactaremos contigo',
    callMakeAppointment: 'Uno de nuestros agentes te llamará para concretar una cita para la instalación de tu fibra.',
    confirm: 'Confirmar',
    summaryTelephoneAppointment: 'Resumen de cita teléfonica:',
    summaryBillsDownload: 'Resumen de descarga',
    successFeedbackDescriptionConfirmDate: 'La cita ha sido modificada correctamente.',
    errorFeedbackDescriptionConfirmDate:
        'Lo sentimos. Por motivos técnicos no se ha podido completar tu solicitud.\n\nPor favor, inténtalo de nuevo más tarde.',
    successFeedbackWeWillContactYou: 'Nos pondremos en contacto contigo.',
    successFeedbackCancelAppointment: 'La cita ha sido anulada correctamente.',
    urlZelerisText: 'Consulta el estado del envío',
    needHelp: '¿Necesitas ayuda?',
    O2cloudTextTitle: 'Almacenamiento gratuito',
    exploreBoxedRowTagO2cloud: 'O2 Cloud',
    O2cloudDescription: '500GB gratis para guardar tus recuerdos de forma segura.',
    installationAppointmentSubstatusCanceled: 'Cita cancelada',
    descriptionCalloutAppointmentCanceled:
        'Si quieres volver a agendar una cita, por favor, ponte en contacto con nosotros en el 1551.',
    titleCurrentPassword: 'Introduce tu contraseña actual:',
    labelCurrentPassword: 'Contraseña actual',
    password: 'Contraseña',
    titleGcoFlow: 'Volver a facturas',
    subtitleGcoFlow: 'Para volver a la sección Facturas, pulsa en el siguiente botón',
    descriptionCalloutLoginMobileConnect:
        'Si te identificas con tu línea, solo tendrás acceso en modo consulta al consumo y prestaciones de la misma.',
    cardO2cloudDescription: '500GB gratis para guardar tus recuerdos de forma segura.',
    billDetailPassCalloutDescription: 'Esta factura es un abono.',
    cardTelevisionTitleHome: 'Movistar Plus+ a un precio especial por ser de O2',
    cardTelevisionTitleExplore: 'Movistar Plus+ en O2',
    cardTelevisionDescriptionExplore: 'La tarifa de 50€ con un partido por jornada, cine y series.',
    cardTelevisionTagText: 'Televisión',
    allChipText: 'Todo',
    tvChipText: 'TV',
    autodiagnosisDescriptionCalloutContacNumber:
        'Si necesitas que contactemos con otro número, debes iniciar sesión como Titular y abrir una nueva incidencia.',
    obdErrorDaonDynamic:
        'No hemos podido capturar correctamente el documento o no es válido. Por favor, realiza la verificación de nuevo.',
    descriptionTextCardO2CloudHome: 'Almacena tus recuerdos de forma segura',
    tagCardO2CloudHome: 'Alm. gratuito',
    titleCardTvHome: 'Movistar Plus+ en O2',
    descriptionTextCardTvHome: 'La tarifa de 50€ con un partido por jornada, cine y series.',
    descriptionTextCardDevicesHome: 'Todos los dispositivos a tu alcance',
    titleCardPostsalesHome: 'Todas las tarifas O2',
    descriptionTextCardPostsalesHome: 'Encuentra y modifica nuevas tarifas',
    sectionFeaturedCards: 'DESTACADOS O2',
    buttonLinkCalloutIncidentPending: 'Contactar por Whatsapp',
    blueCardNewTitle: 'Movistar Plus+ en O2',
    blueCardNewSubtitle: 'La tarifa de 50€ con un partido por jornada, cine y series.',
    titleCardDevices: 'Móviles y dispositivos',
    titleModalLogoutChangePassword: 'Cierre de sesión',
    subtitleModalLogoutChangePassword:
        'Tu contraseña se ha modificado correctamente.\nPor tu seguridad, debes volver a iniciar sesión con la nueva contraseña.',
    buttonModalLogoutChangePassword: 'Entendido',
    calloutTitleRemenberPassword: 'Recuerda tu contraseña',
    calloutDescriptionRemenberPassword:
        'Cuando pulses el botón Guardar, se cerrará la sesión actual. Tendrás que volver a iniciar sesión con tu nueva contraseña.',
    orderReadyEmpty: 'Tu pedido está realizado',
    orderProgressEmpty: 'Tu pedido está en curso',
    orderCancel: 'Tu pedido ha sido cancelado',
    orderDetailEmpty: 'Este pedido no tiene más información disponible',
    descriptionCalloutUpdateContact: 'Solo contactaremos contigo con información importante sobre tu servicio.',
    updateContactsVerifiedOtp: 'Introduce el código de verificación que has recibido',
    updateContactsVerifiedOtpMobile: 'por SMS en tu móvil',
    updateContactsVerifiedOtpEmail: 'en tu email',
    descriptionVerifyOtpMobile: 'en tu móvil',
    titleUpdatePersonalDataEmail: 'Introduce el email en el que quieres recibir tus comunicaciones de O2.',
    titleUpdatePersonalDataMobile: 'Introduce el móvil en el que quieres recibir tus comunicaciones de O2.',
    verificadeCode: 'Verificación de código',
    descriptionVerifyText1: 'Te vamos a enviar un código a tu contacto ',
    descriptionVerifyText2: ', para asegurarnos de que la operación se realiza de forma segura.',
    descriptionVerifyText3: 'Por favor no cierres esta pantalla hasta finalizar',
    descriptionFeedbackSuccesOtpMobile: 'Tu número de móvil se ha verificado correctamente.',
    descriptionFeedbackSuccesOtpEmail: 'Tu dirección de email se ha verificado correctamente.',
    descriptionEscalationTitle:
        'Por seguridad, necesitamos verificar que eres tú. Para ello vamos a enviarte un código al medio que elijas.',
    buttonReceiveCode: 'Recibir código',
    profileCardObdTitleOneVerified: 'Finaliza la verificación de tus datos',
    snackBarProfileBtn: ' Ver Perfil',
    snackBarProfileText: ' Verifica tus medios de contacto',
    buyDevice: 'COMPRA',
    dateDeviceBuy: 'Fecha de compra',
    deviceBuyAllPrice: 'Total',
    devicePrice: 'Precio',
    titleFAQsOrders: 'FAQs',
    subtitleFAQsOrders: 'RESUELVE TUS DUDAS SOBRE O2',
    trackingSIMFaq: 'Seguimiento de la SIM de O2',
    instalationFiberFaq: 'Plazo y proceso de instalación de la fibra',
    changeNumberFaq: 'Cambio de tu número a O2',
    habitualErrorsFaq: 'Errores habituales en la portabilidad',
    questionsMoviestarFaq: 'Dudas frecuentes si vienes de Movistar',
    transferProcessFaq: 'Plazo y proceso de un traslado de fibra',
    shipmentDeviceFaq: 'Envío y entrega del dispositivo',
    titleTimeLineOrders: 'Seguimiento de pedido',
    subtitleTimeLineOrders: 'DETALLE DE SEGUIMIENTO',
    actualStatus: 'Estado actual',
    trackingInfoBtn: 'Ver seguimineto de pedido',
    UpdatePersonalDataLabelEmail: 'Email',
    UpdatePersonalDataHelperTextEmail: 'Este email ya está verificado, prueba con otro diferente.',
    UpdatePersonalDataHelperTextMobile: 'Este móvil ya está verificado, prueba con otro diferente.',
    cardFlexAddLineTitle: 'Añade una línea móvil',
    cardFlexAddLineDescription: 'Disfruta de nuestras tarifas, y añade una nueva línea a tu plan.',
    cardFlexGoToConvergentTitle: 'Pásate a Fibra y Móvil',
    cardFlexGoToConvergentDescription: 'Completa tu servicio con una de nuestras tarifas de Fibra y Móvil.',
    moreInformationLink: 'Ver más información',
    appoinmetInfoTitle: 'CITA INSTALACIÓN',
    appoinmetInfoCallOutTitle: 'Recuerda llevarte los equipos',
    appoinmetInfoCallOutDescription:
        'Para llevar a cabo el traslado, es necesario que lleves tu router y el resto de equipos al nuevo domicilio.',
    appoinmentInfoCallOutBtnLink: '¿Qué llevar en mi traslado?',
    trackingInfoTitle: 'ENVIO',
    trackingInfoTime: 'Recepción transporte',
    trackingInfoTextBtn: 'Ver seguimiento de envío',
    trackingInfoBackTitle: 'Detalle de seguimiento',
    trackingInfoObservations: 'Observaciones:',
    portabilityInfoTitle: 'PORTABILIDADES',
    portabilityInfoDateTitle: 'Fecha de portabilidad:',
    newLinesNumbersTitle: 'ALTAS',
    whatsappBtn: 'Whatsapp',
    numberTlfBtn: 'Llamar al 1551',
    orderDetailTextIncidence:
        'Hemos detectado una incidencia en tu pedido y estamos trabajando para solucionarlo. Nos encargaremos de todo y actualizaremos el estado de la incidencia',

    //configureLine-Esim
    configESIMTitle: 'Configuración eSIM',
    managmentESIMTitle: 'Gestión eSIM',
    eSIMInstallTitle: 'Instalar eSIM',
    eSimInstallWarning: 'Instala tu eSIM',
    simActiveWarning: 'Activa tu SIM',
    eSIMDescription: 'Duplica y gestiona tu eSIM',
    eSIMInstallDescription: 'Activa y gestiona tu eSIM',
    selectProcesseSIM: 'Selecciona el proceso que quieres gestionar:',
    duplicateeSIM: 'Solicitar duplicado eSIM',
    duplicateRequest: 'Solicitud de duplicado',
    multiSimRequestHeader: 'Solicitud de MultiSIM',
    multiSimActivationWarning: 'Activa tu MultiSIM',
    requestSummary: 'Resumen de la solicitud',
    simActivation: 'Activación de SIM',
    duplicateRequestCallout: 'Recibirás un email con los detalles de la solicitud de Duplicado.',
    duplicateRequestCalloutMultiSim: 'Recibirás un email con los detalles de la solicitud de multisim.',
    simFeedbackSuccess:
        'Se ha realizado correctamente tu petición de duplicado de la SIM.\n\nTe enviaremos un email en las próximas horas para confirmarte la solicitud.',
    esimFeedbackSuccess:
        'Estamos procesando tu eSIM y en breve podrás instalarla.\n\nCuando esté preparada, verás el aviso en la pantalla principal de la app.',
    eSimFeedbackSuccessTitle: 'Tu eSIM está casi lista',
    simActivationSuccessTitle: 'Activación completada',
    simActivationSuccessDescription: 'Tu SIM ya se ha activado correctamente.',
    duplicateMultiSimSuccessTitle: 'Solicitud de MultiSIM completada',
    duplicateMultiESimSuccessTitle: 'Solicitud de Multi eSIM completada',
    duplicateMultiSimSuccessDesc:
        'Tu solicitud de MultiSIM ha sido procesada. Puedes seguir el proceso en Pedidos en Perfil.',
    duplicateMultiESimSuccessDesc:
        'Tu solicitud de Multi eSIM ha sido procesada.\n\nTe enviaremos un mail con la información necesaria para la activación.',
    selectSimType: 'Selecciona el tipo de tarjeta para tu línea móvil',
    selectMultiSimType: 'Selecciona el tipo de la línea móvil que quieras activar la MultiSIM:',
    multiSimCostCallout:
        'La activación del servicio MultiSIM tiene un coste de 5€/mes. Puedes activar hasta dos MultiSIM.',
    seeQRInstall: 'Ver QR de Instalación',
    secondaryBtn: 'Lo haré más tarde',
    thisDiviceTitle: 'En este dispositivo',
    thisDiviceDescription: 'La activación de esta opción, puede tardar unos minutos.',
    anotherDiveTitle: 'En otro dispositivo',
    anotherDiveDescription: 'Te facilitaremos un código QR, para instalar la eSim.',
    calloutWiFiTitle: 'Recuerda activar el Wifi',
    calloutWiFiDescription:
        'Necesitas estar conectado a una red Wifi para instalar la e-SIM. Si ahora no es posible, selecciona hacerlo más tarde.',
    whereToInstallTitleeSIM: '¿Dónde quieres instalar la eSIM?',
    iccNumberInputLabel: 'Completa el número ICC',
    iccNumberInputHelperText:
        'Puedes encontrar los 4 últimos dígitos en el reverso de la tarjeta SIM.\nEl formato debe ser XXX X.',
    feedbackDuplicateESIMTitle: 'Tu eSIM está casi lista',
    feedbackDuplicateESIMDescription1:
        'Estamos procesando tu eSIM y en breve podrás instalarla.\n\nCuando esté preparada, verás el aviso en la pantalla de inicio',
    feedbackInstalleSIMTitle: 'Instalación completada',
    feedbackInstalleSIMDescription: 'La instalación de tu eSIM se ha realizado correctamente.',
    feedbackInstallErroreSIMTitle: 'Instalación no finalizada',
    feedbackInstallErroreSIMDescription:
        'Lo sentimos, no hemos podido activar el servicio eSIM. Por favor, inténtalo más tarde. Si el problema persiste, ponte en contacto con nosotros en el 155',
    intallWithQRtitle: 'Instalación eSIM ',
    InstallWithQRDescription: '  Escanea este código QR con la cámara de tu dispositivo y sigue las instrucciones.',
    finish: 'Finalizar',
    supportContentTitleManagement: '¿Necesitas realizar alguna gestión?',
    supportContentRowChangeBankAccount: 'Cambio de cuenta bancaria',
    transferInformation: 'Información de traslado',
    rememberToTake: 'Recuerda llevarte:',
    router: 'El Router',
    adapter: 'El adaptador',
    ethernetCable: 'El cable Ethernet',
    dialogtitleEsim: 'Información importante',
    dialogTextEsim:
        'Actualmente tienes el servicio Multisim activo.\n\nContacta con el 1551 para solicitar un duplicado.',
    importantNoticeTitle: 'Aviso importante',
    importantNoticeDescription:
        'Una vez solicites un duplicado eSIM, tu línea SIM quedará desactivada. Asegúrate de que el dispositivo donde quieres instalarla es compatible.',
    feedbackQrTitle: 'Ya puedes configurar tu eSIM',
    feedbackQrDescription: 'Recuerda que necesitas estar conectado a una red WiFi para instalar la eSIM.',
    seeQRBtn: 'Ver código',
    qrBreadcrumbs: 'Qr eSIM',
    dialogTimerDuplicateEsimTitle: 'Servicio no disponible',
    dialogTimerDuplicateEsimDescription1: 'Actualmente no puedes realizar otro duplicado de la línea.',
    dialogTimerDuplicateEsimDescription2: 'Inténtalo de nuevo más tarde.',
    contentTitleDevicesList: 'TUS DISPOSITIVOS',
    freeDevice: 'Dispositivo libre',
    includeDevice: 'Dispositivo incluído',
    youDevice: 'TU DISPOSITIVO',
    deviceDetailPrice: 'PRECIO',
    profilePersonalDataDescription:
        'Al acceder encontrarás tus medios de contacto; móvil de contacto, correo electrónico, y cuenta bancaria.',
    btnAcces: 'Acceder',
    personalDataTitle2: 'Datos personales',
    bankAccountTitle: 'CAMBIAR CUENTA BANCARIA',
    personalDataUpdateMobileTitle: 'Móvil de contacto',
    personalDataUpdateEmailTitle: 'Email de contacto',
    breadcrumbsTitleBillDetail: 'Detalle factura',
    escalationContactsCalloutDescription:
        'Si quieres añadir un nuevo medio de contacto, puedes hacerlo desde Perfil>Datos personales>Verificación avanzada',
    duplicateESIMVersionDigital: 'Versión digital',
    statusTag: 'Activada',
    statusMultiSim: 'Pendiente de activar',
    buttonLinkAddMultisim: 'Añadir MultiSIM',
    multisimCalloutTitle: 'Desactivar MultiSIM/eSIM',
    multisimCalloutDescription: 'Desactiva tu servicio multiSIM llamando al 1551.',
    activateSimPhysicalTitle:
        'Introduce los cuatro últimos dígitos del número de identificación (ICC) de la tarjeta SIM:',
    feedbackMultisimDescription:
        'Se ha realizado correctamente los cambios realizados.\n\nPuedes tardar unos minutos en hacerse efectivo.',
    multisimAddLimitAlert: 'Ya has contratado al máximo de MultiSIM (2),\n\nContacta con el 1551 para más información.',
    multiSimPendingAlert: 'No se pueden solicitar una nueva MultiSIM si tienes otra pendiente de activar',
    back: 'Volver',
    Entertainment: 'Entretenimiento',
    orderDetailsIncidentTextGeneric:
        'Hemos detectado una incidencia en tu pedido y estamos trabajando para solucionarlo. Nos encargaremos de todo y actualizaremos el estado de la incidencia.',
    confirmUnlock: 'Confirmar desbloqueo de línea',
    confirmLock: 'Confirmar bloqueo de línea',
    debtPaymentPageTitle: 'Facturas a pagar',
    modalDebtPaymentPendingBills: 'Facturas pendientes',
    modalDebtPaymentPendingBillsDescription: 'Accede para revisarlas y realizar el pago.',
    modalDebtPaymentReviewButton: 'Revisar',
    debtRehabilitationCardTitle: 'Rehabilitación de líneas',
    debtRehabilitationCardDescription: 'Reactiva tus líneas de forma temporal y paga en las próximas 48 horas.',
    debtRehabilitationMoreInfoLink: 'Más información',
    debtPaymentReviewButton: 'Revisar',
    PaymentdebtModalHeader: 'Pago',
};
